import { Box } from '@mui/material';

import { Typography } from '@zendesk/forethought-elements';

interface FilterLabelContainerProps {
  children: React.ReactNode;
  label: string;
  labelVariant?: 'font14Bold' | 'font14Medium';
}

const FilterLabelContainer = ({
  children,
  label,
  labelVariant = 'font14Bold',
}: FilterLabelContainerProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}
    >
      <Typography variant={labelVariant}>{label}</Typography>
      {children}
    </Box>
  );
};

export default FilterLabelContainer;
